import partnerHucffLogo from "./logo_hucff.png";
import coppeLogo from "./Logo_COPPE_-_UFRJ.jpg";
import incubadoraLogo from "./logo_incubadora.png";
import faperjLogo from "./logo_faperj_vinho_completo.png";
import fundepLogo from "./fundep_logo.png";
import hospitalDeAmorLogo from "./hospital_de_amor.jpg";
import aceleraNiteroiLogo from "./acelera_niteroi.png";
import apexBrasilLogo from "./apex_brasil.png";
import bndesGaragemLogo from "./bndes_garagem.png";
import catalisaIctLogo from "./catalisa_ict.png";
import coppeadUfrjLogo from "./coppead_ufrj.png";
import epicentroIaLogo from "./epicentro_ia.png";
import hcUnicampLogo from "./hc_unicamp.png";
import ibmecHubsLogo from "./ibmec_hubs.png";
import prointerBiotechLogo from "./prointer_biotech.png";
import pucRioEcoaLogo from "./puc_rio_ecoa.png";
import sebraeLogo from "./sebrae.png";
import wylinkaLogo from "./wylinka.png";
import risingUpInSpainLogo from "./rising_up_in_spain.png";

const partnersIndex = [
  {
    name: "FAPERJ",
    logo: faperjLogo,
    link: "https://www.faperj.br/",
  },
  {
    name: "FUNDEP",
    logo: fundepLogo,
    link: "https://www.fundep.ufmg.br/",
  },
  {
    name: "COPPE-UFRJ",
    logo: coppeLogo,
    link: "https://www.coppe.ufrj.br/",
  },
  {
    name: "Incubadora de empresas UFRJ",
    logo: incubadoraLogo,
    link: "https://incubadora.coppe.ufrj.br/",
  },
  {
    name: "HUCFF",
    logo: partnerHucffLogo,
    link: "http://www.hucff.ufrj.br/",
  },
  {
    name: "Hospital de Amor",
    logo: hospitalDeAmorLogo,
    link: "https://hospitaldeamor.com.br/",
  },
  {
    name: "Programa Acelera Niterói",
    logo: aceleraNiteroiLogo,
    link: "https://aceleraniteroi.org.br/",
  },
  {
    name: "Apex Brasil",
    logo: apexBrasilLogo,
    link: "https://www.apexbrasil.com.br/",
  },
  {
    name: "BNDES Garagem",
    logo: bndesGaragemLogo,
    link: "https://garagem.bndes.gov.br/",
  },
  {
    name: "Catalisa ICT",
    logo: catalisaIctLogo,
    link: "https://www.sebrae.com.br/catalisaict",
  },
  {
    name: "COPPEAD UFRJ",
    logo: coppeadUfrjLogo,
    link: "https://www.coppead.ufrj.br/",
  },
  {
    name: "Epicentro da Inteligência Artificial",
    logo: epicentroIaLogo,
    link: "https://www.akcit.org/",
  },
  {
    name: "HC Unicamp",
    logo: hcUnicampLogo,
    link: "https://hc.unicamp.br/",
  },
  {
    name: "Ibmec HUBs",
    logo: ibmecHubsLogo,
    link: "https://www.ibmec.br/",
  },
  {
    name: "Prointer Bio&Tech",
    logo: prointerBiotechLogo,
    link: "https://www.sebrae.com.br/",
  },
  {
    name: "PUC-Rio ECOA",
    logo: pucRioEcoaLogo,
    link: "https://ecoa.puc-rio.br/",
  },
  {
    name: "SEBRAE",
    logo: sebraeLogo,
    link: "https://www.sebrae.com.br/",
  },
  {
    name: "Wylinka",
    logo: wylinkaLogo,
    link: "https://www.wylinka.org.br/",
  },
  {
    name: "Rising UP in Spain",
    logo: risingUpInSpainLogo,
    link: "https://www.investinspain.org/content/icex-invest/en/rising-up-in-spain.html",
  },
];

export default partnersIndex;

